import React from 'react'
import { Tag } from 'antd'
import { t } from 'i18next'

export default function EventTag ({ tag, type }) {
  let path = ''
  if (type === 'businessArea') {
    path = 'Admin.Tag.businessArea'
  } else if (type === 'family') {
    path = 'Admin.Tag.family'
  } else if (type === 'tag') {
    path = 'Admin.Tag'
  }
  return <Tag key={tag.id} color={tag.color} variant='solid'>{t(`${path}.${tag.name}`)}</Tag>
}
